/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigDecimal: { input: any; output: any; }
  /** The Long scalar type represents a signed 64-bit numeric non-fractional value */
  Long: { input: any; output: any; }
  /** The Short scalar type represents a signed 16-bit numeric non-fractional value */
  Short: { input: any; output: any; }
  TbaDate: { input: any; output: any; }
  TbaUuid: { input: any; output: any; }
};

/** Access level for bidding deposits */
export enum AccessType {
  Auction = 'AUCTION',
  Channel = 'CHANNEL',
  Lot = 'LOT',
  Platform = 'PLATFORM'
}

export type AdditionalCost = {
  __typename?: 'AdditionalCost';
  type: CostType;
  value: Money;
};

/** Additional costs object */
export type AdditionalCosts = {
  __typename?: 'AdditionalCosts';
  costs: Array<AdditionalCost>;
};

export type AdditionalInformationInput = {
  auctionId: Scalars['TbaUuid']['input'];
  locale: Scalars['String']['input'];
  platform: Platform;
};

export type AdditionalInformationResponse = {
  __typename?: 'AdditionalInformationResponse';
  additionalInformation?: Maybe<Scalars['String']['output']>;
};

export type AllAuctionsFacet = {
  identifier: AllAuctionsFacetName;
  values: Array<Scalars['String']['input']>;
};

/** Supported facets on all auctions page */
export enum AllAuctionsFacetName {
  Countries = 'countries'
}

export type AllAuctionsInput = {
  biddingStatuses: Array<BiddingStatus>;
  facets: Array<AllAuctionsFacet>;
  hideZeroLotAuctions: Scalars['Boolean']['input'];
  locale: Scalars['String']['input'];
  pageNumber: Scalars['Long']['input'];
  pageSize: Scalars['Long']['input'];
  rangeFacets: Array<AuctionRangeFacetInput>;
  sortBy: AuctionsSortingOption;
};

export type AllAuctionsWithLotDataInput = {
  biddingStatuses: Array<BiddingStatus>;
  facets: Array<AllAuctionsFacet>;
  hideZeroLotAuctions: Scalars['Boolean']['input'];
  locale: Scalars['String']['input'];
  pageNumber: Scalars['Long']['input'];
  pageSize: Scalars['Long']['input'];
  sortBy: AuctionsSortingOption;
};

export type AllGroupsFacet = {
  identifier: AllGroupsFacetName;
  values: Array<Scalars['String']['input']>;
};

/** Supported facets on all groups page */
export enum AllGroupsFacetName {
  Countries = 'countries'
}

export type AllGroupsInput = {
  biddingStatuses: Array<BiddingStatus>;
  facets: Array<AllGroupsFacet>;
  locale: Scalars['String']['input'];
  pageNumber: Scalars['Long']['input'];
  pageSize: Scalars['Long']['input'];
  rangeFacets: Array<GroupRangeFacetInput>;
  sortBy: GroupsSortingOption;
};

/** Auction object */
export type Auction = {
  __typename?: 'Auction';
  additionalInformation: Scalars['Boolean']['output'];
  auctionType: Scalars['String']['output'];
  biddingStatus: BiddingStatus;
  collectionDays: Array<AuctionLocation>;
  deliveryCountries: Array<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  displayId: Scalars['String']['output'];
  documents: Array<Document>;
  endDate: Scalars['TbaDate']['output'];
  id: Scalars['TbaUuid']['output'];
  image: Image;
  images: Array<Image>;
  isNeedsDelivery: Scalars['Boolean']['output'];
  lotCount: Scalars['Long']['output'];
  lotsClosing: Scalars['Boolean']['output'];
  mainImage?: Maybe<Image>;
  maxEndDate: Scalars['TbaDate']['output'];
  minEndDate: Scalars['TbaDate']['output'];
  name: Scalars['String']['output'];
  onBoarding: Scalars['Boolean']['output'];
  otherUrlSlugs: Array<LocalizedValue>;
  platform: Platform;
  showFrom: Scalars['TbaDate']['output'];
  showUntil: Scalars['TbaDate']['output'];
  startDate: Scalars['TbaDate']['output'];
  url3dTour?: Maybe<Scalars['String']['output']>;
  urlSlug: Scalars['String']['output'];
  viewingDays: Array<AuctionLocation>;
};


/** Auction object */
export type AuctionCollectionDaysArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** Auction object */
export type AuctionDeliveryCountriesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** Auction object */
export type AuctionViewingDaysArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type AuctionDisplayIdResponse = {
  __typename?: 'AuctionDisplayIdResponse';
  displayId: Scalars['String']['output'];
};

/** Object containing auction displayIds */
export type AuctionDisplayIdsResponse = {
  __typename?: 'AuctionDisplayIdsResponse';
  hasNext: Scalars['Boolean']['output'];
  pageNumber: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  results: Array<AuctionDisplayIdResponse>;
  totalSize: Scalars['Long']['output'];
};

/** Auction Facets result object */
export type AuctionFacetsResponse = {
  __typename?: 'AuctionFacetsResponse';
  appliedRangeFacets: Array<AuctionRangeFacetRequest>;
  appliedValueFacets: Array<AuctionValueFacetRequest>;
  rangeFacets: Array<AuctionRangeFacet>;
  valueFacets: Array<AuctionValueFacet>;
};

/** Auction Location object */
export type AuctionLocation = {
  __typename?: 'AuctionLocation';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['TbaUuid']['output'];
  locationDays?: Maybe<Array<AuctionLocationDay>>;
  name?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
};

/** Auction Location Day object */
export type AuctionLocationDay = {
  __typename?: 'AuctionLocationDay';
  email?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Long']['output']>;
  forkliftCapacity?: Maybe<Scalars['Int']['output']>;
  isByAppointment: Scalars['Boolean']['output'];
  isDeliverySchedule?: Maybe<Scalars['Boolean']['output']>;
  isForkliftAvailable?: Maybe<Scalars['Boolean']['output']>;
  showOnWebsite?: Maybe<Scalars['Boolean']['output']>;
  startDate?: Maybe<Scalars['Long']['output']>;
};

/** Object containing next & previous lots' url slugs */
export type AuctionNavigation = {
  __typename?: 'AuctionNavigation';
  nextLotUrlSlug: Scalars['String']['output'];
  prevLotUrlSlug: Scalars['String']['output'];
};

export type AuctionNavigatorInput = {
  auctionDisplayId: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  lotDisplayId: Scalars['String']['input'];
  lotNumber: Scalars['String']['input'];
  platform: Platform;
};

/** All auction range facets for the result set. */
export type AuctionRangeFacet = {
  __typename?: 'AuctionRangeFacet';
  identifier: AuctionRangeFacetName;
  max: Scalars['Long']['output'];
  min: Scalars['Long']['output'];
};

export type AuctionRangeFacetInput = {
  identifier: AuctionRangeFacetName;
  max: Scalars['Long']['input'];
  min: Scalars['Long']['input'];
};

/** Supported range facets on all auctions page */
export enum AuctionRangeFacetName {
  EndDates = 'endDates'
}

/** The auction range facets to be applied. */
export type AuctionRangeFacetRequest = {
  __typename?: 'AuctionRangeFacetRequest';
  identifier: AuctionRangeFacetName;
  max: Scalars['Long']['output'];
  min: Scalars['Long']['output'];
};

/** All auction value facets for the result set. */
export type AuctionValueFacet = {
  __typename?: 'AuctionValueFacet';
  filters: Array<Filter>;
  identifier: AuctionValueFacetName;
};

export type AuctionValueFacetInput = {
  filters: Array<Scalars['String']['input']>;
  identifier: AuctionValueFacetName;
};

/** Supported facets on auctions page */
export enum AuctionValueFacetName {
  Countries = 'countries'
}

/** The auction value facets to be applied. */
export type AuctionValueFacetRequest = {
  __typename?: 'AuctionValueFacetRequest';
  filters: Array<Scalars['String']['output']>;
  identifier: AuctionValueFacetName;
};

/** Auction object containing paged auction's lots with limited data */
export type AuctionWithListingLots = {
  __typename?: 'AuctionWithListingLots';
  auction: Auction;
  lots: ListingLots;
};

/** Object containing an auction with lotData (capped at 4 lots) */
export type AuctionWithLotData = {
  __typename?: 'AuctionWithLotData';
  auction: Auction;
  lots: Array<LotData>;
};

/** Auction object containing paged auction's lots */
export type AuctionWithLots = {
  __typename?: 'AuctionWithLots';
  auction: Auction;
  lots: Lots;
};

/** Input to fetch auction with lots */
export type AuctionWithLotsInput = {
  displayId: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  lotBiddingStatuses: Array<BiddingStatus>;
  pageNumber: Scalars['Long']['input'];
  pageSize: Scalars['Long']['input'];
  rangeFacetInputs: Array<LotRangeFacetInput>;
  sortBy: LotsSortingOption;
  valueFacetInputs: Array<LotsByAuctionValueFacetInput>;
};

/** Input to fetch auction with lots */
export type AuctionWithLotsInputV3 = {
  displayId: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  pageNumber: Scalars['Long']['input'];
  pageSize: Scalars['Long']['input'];
  rangeFacetInputs: Array<LotRangeFacetInput>;
  sortBy: LotsSortingOption;
  valueFacetInputs: Array<LotsByAuctionValueFacetInput>;
};

/** Supported auctioneers */
export enum Auctioneer {
  BmaGb = 'BMA_GB',
  Dechow = 'DECHOW',
  HtDe = 'HT_DE',
  Kda = 'KDA',
  KvkFi = 'KVK_FI',
  SpxAt = 'SPX_AT',
  SpxBe = 'SPX_BE',
  SpxBg = 'SPX_BG',
  SpxCh = 'SPX_CH',
  SpxCz = 'SPX_CZ',
  SpxDe = 'SPX_DE',
  SpxEe = 'SPX_EE',
  SpxEs = 'SPX_ES',
  SpxFr = 'SPX_FR',
  SpxGb = 'SPX_GB',
  SpxHr = 'SPX_HR',
  SpxHu = 'SPX_HU',
  SpxIt = 'SPX_IT',
  SpxNl = 'SPX_NL',
  SpxPl = 'SPX_PL',
  SpxPt = 'SPX_PT',
  SpxRo = 'SPX_RO',
  SpxSe = 'SPX_SE',
  SpxSi = 'SPX_SI',
  SpxSk = 'SPX_SK',
  Tba = 'TBA',
  TwkBe = 'TWK_BE',
  TwkCh = 'TWK_CH',
  TwkFr = 'TWK_FR',
  TwkIt = 'TWK_IT',
  TwkRestOfWorld = 'TWK_REST_OF_WORLD',
  Vavato = 'VAVATO'
}

/** Auctions list object */
export type Auctions = {
  __typename?: 'Auctions';
  hasNext: Scalars['Boolean']['output'];
  pageNumber: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  results: Array<Auction>;
  totalSize: Scalars['Long']['output'];
};

export type AuctionsByStateInput = {
  hideZeroLotAuctions: Scalars['Boolean']['input'];
  locale: Scalars['String']['input'];
  numberOfDays: Scalars['Long']['input'];
  pageNumber: Scalars['Long']['input'];
  pageSize: Scalars['Long']['input'];
  platform: Platform;
  sortBy: AuctionsSortingOption;
};

export type AuctionsByStateInputV2 = {
  hideZeroLotAuctions: Scalars['Boolean']['input'];
  locale: Scalars['String']['input'];
  numberOfDays: Scalars['Long']['input'];
  pageNumber: Scalars['Long']['input'];
  pageSize: Scalars['Long']['input'];
  sortBy: AuctionsSortingOption;
};

/** Sort property for the all auctions query */
export enum AuctionsSortingOption {
  EndDateAsc = 'END_DATE_ASC',
  EndDateDesc = 'END_DATE_DESC',
  StartDateAsc = 'START_DATE_ASC',
  StartDateDesc = 'START_DATE_DESC'
}

/** Object containing auctions and per auction a subset of data for its lots (capped at 4 lots) */
export type AuctionsWithLotData = {
  __typename?: 'AuctionsWithLotData';
  hasNext: Scalars['Boolean']['output'];
  pageNumber: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  results: Array<AuctionWithLotData>;
  totalSize: Scalars['Long']['output'];
};

export type BidRequest = {
  amountInCents: Scalars['Long']['input'];
  bidType: BidType;
  currency: Currency;
  lotId: Scalars['TbaUuid']['input'];
};

/** Current bid status of a buyerId for a lot */
export enum BidStatus {
  Highest = 'HIGHEST',
  NoBid = 'NO_BID',
  Outbid = 'OUTBID'
}

/** The type of bid, enum REGULAR_BID or AUTO_BID */
export enum BidType {
  AutoBid = 'AUTO_BID',
  RegularBid = 'REGULAR_BID'
}

/** Filter on auctions and lots where the bidding is open, not yet open or closed */
export enum BiddingStatus {
  BiddingClosed = 'BIDDING_CLOSED',
  BiddingNotYetOpened = 'BIDDING_NOT_YET_OPENED',
  BiddingOpen = 'BIDDING_OPEN'
}

/** The sellers type of business */
export enum BusinessType {
  Company = 'COMPANY',
  CompanyLight = 'COMPANY_LIGHT',
  Individual = 'INDIVIDUAL',
  Liquidator = 'LIQUIDATOR',
  NonProfit = 'NON_PROFIT'
}

/** Category object */
export type Category = {
  __typename?: 'Category';
  id: Scalars['TbaUuid']['output'];
  name: Scalars['String']['output'];
  otherUrlSlugs: Array<LocalizedValue>;
  parentId: Scalars['TbaUuid']['output'];
  urlSlug: Scalars['String']['output'];
};

/** An Category attribute on a lot */
export type CategoryAttribute = {
  __typename?: 'CategoryAttribute';
  name: Scalars['String']['output'];
  unit?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** The level of category, level 1 is main, 2 is category and 3 is sub category */
export enum CategoryLevel {
  Level1 = 'LEVEL1',
  Level2 = 'LEVEL2',
  Level3 = 'LEVEL3'
}

/** Type of additional costs */
export enum CostType {
  Delivery = 'DELIVERY'
}

/** Currency identifier */
export enum Currency {
  Aed = 'AED',
  Afn = 'AFN',
  All = 'ALL',
  Amd = 'AMD',
  Ang = 'ANG',
  Aoa = 'AOA',
  Ars = 'ARS',
  Aud = 'AUD',
  Awg = 'AWG',
  Azn = 'AZN',
  Bam = 'BAM',
  Bbd = 'BBD',
  Bdt = 'BDT',
  Bgn = 'BGN',
  Bhd = 'BHD',
  Bif = 'BIF',
  Bmd = 'BMD',
  Bnd = 'BND',
  Bob = 'BOB',
  Brl = 'BRL',
  Bsd = 'BSD',
  Btn = 'BTN',
  Bwp = 'BWP',
  Byn = 'BYN',
  Bzd = 'BZD',
  Cad = 'CAD',
  Cdf = 'CDF',
  Chf = 'CHF',
  Clp = 'CLP',
  Cny = 'CNY',
  Cop = 'COP',
  Crc = 'CRC',
  Cup = 'CUP',
  Cve = 'CVE',
  Czk = 'CZK',
  Djf = 'DJF',
  Dkk = 'DKK',
  Dop = 'DOP',
  Dzd = 'DZD',
  Egp = 'EGP',
  Ern = 'ERN',
  Etb = 'ETB',
  Eur = 'EUR',
  Fjd = 'FJD',
  Fkp = 'FKP',
  Gbp = 'GBP',
  Gel = 'GEL',
  Ghs = 'GHS',
  Gip = 'GIP',
  Gmd = 'GMD',
  Gnf = 'GNF',
  Gtq = 'GTQ',
  Gyd = 'GYD',
  Hkd = 'HKD',
  Hnl = 'HNL',
  Htg = 'HTG',
  Huf = 'HUF',
  Idr = 'IDR',
  Ils = 'ILS',
  Inr = 'INR',
  Iqd = 'IQD',
  Irr = 'IRR',
  Isk = 'ISK',
  Jmd = 'JMD',
  Jod = 'JOD',
  Jpy = 'JPY',
  Kes = 'KES',
  Kgs = 'KGS',
  Khr = 'KHR',
  Kmf = 'KMF',
  Kpw = 'KPW',
  Krw = 'KRW',
  Kwd = 'KWD',
  Kyd = 'KYD',
  Kzt = 'KZT',
  Lak = 'LAK',
  Lbp = 'LBP',
  Lkr = 'LKR',
  Lrd = 'LRD',
  Lyd = 'LYD',
  Mad = 'MAD',
  Mdl = 'MDL',
  Mga = 'MGA',
  Mkd = 'MKD',
  Mmk = 'MMK',
  Mnt = 'MNT',
  Mop = 'MOP',
  Mru = 'MRU',
  Mur = 'MUR',
  Mvr = 'MVR',
  Mwk = 'MWK',
  Mxn = 'MXN',
  Myr = 'MYR',
  Mzn = 'MZN',
  Nad = 'NAD',
  Ngn = 'NGN',
  Nio = 'NIO',
  Nok = 'NOK',
  Npr = 'NPR',
  Nzd = 'NZD',
  Omr = 'OMR',
  Pab = 'PAB',
  Pen = 'PEN',
  Pgk = 'PGK',
  Php = 'PHP',
  Pkr = 'PKR',
  Pln = 'PLN',
  Pyg = 'PYG',
  Qar = 'QAR',
  Ron = 'RON',
  Rsd = 'RSD',
  Rub = 'RUB',
  Rwf = 'RWF',
  Sar = 'SAR',
  Sbd = 'SBD',
  Scr = 'SCR',
  Sdg = 'SDG',
  Sek = 'SEK',
  Sgd = 'SGD',
  Shp = 'SHP',
  Sle = 'SLE',
  Sos = 'SOS',
  Srd = 'SRD',
  Ssp = 'SSP',
  Stn = 'STN',
  Syp = 'SYP',
  Szl = 'SZL',
  Thb = 'THB',
  Tjs = 'TJS',
  Tmt = 'TMT',
  Tnd = 'TND',
  Top = 'TOP',
  Try = 'TRY',
  Ttd = 'TTD',
  Twd = 'TWD',
  Tzs = 'TZS',
  Uah = 'UAH',
  Ugx = 'UGX',
  Usd = 'USD',
  Uyu = 'UYU',
  Uzs = 'UZS',
  Ves = 'VES',
  Vnd = 'VND',
  Vuv = 'VUV',
  Wst = 'WST',
  Xaf = 'XAF',
  Xcd = 'XCD',
  Xof = 'XOF',
  Xpf = 'XPF',
  Xxx = 'XXX',
  Yer = 'YER',
  Yum = 'YUM',
  Zar = 'ZAR',
  Zmw = 'ZMW'
}

/** A custom attribute on a lot for internal use */
export type CustomAttribute = {
  __typename?: 'CustomAttribute';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Defines the date and time of the viewing or collection day of the lot */
export type Day = {
  __typename?: 'Day';
  email?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['TbaDate']['output']>;
  forkliftCapacity?: Maybe<Scalars['Int']['output']>;
  isByAppointment: Scalars['Boolean']['output'];
  isDeliverySchedule: Scalars['Boolean']['output'];
  isForkliftAvailable: Scalars['Boolean']['output'];
  startDate?: Maybe<Scalars['TbaDate']['output']>;
};

/** Returns deposit type & amount */
export type Deposit = {
  __typename?: 'Deposit';
  amount: Money;
  triggerAmount: Money;
  type: DepositType;
};

/** Non personalised deposit badge information */
export enum DepositBadge {
  DepositNotRequired = 'DEPOSIT_NOT_REQUIRED',
  DepositRequired = 'DEPOSIT_REQUIRED',
  DepositRequirementNotReached = 'DEPOSIT_REQUIREMENT_NOT_REACHED'
}

export type DepositStatusInput = {
  platform: Platform;
};

/** Response for the buyer deposit status */
export type DepositStatusResponse = {
  __typename?: 'DepositStatusResponse';
  access: Scalars['Boolean']['output'];
  accessType: AccessType;
};

/** Type of deposit */
export enum DepositType {
  Buyer = 'BUYER',
  Platform = 'PLATFORM'
}

/** Sort order */
export enum Direction {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Auction & lot document object */
export type Document = {
  __typename?: 'Document';
  name: Scalars['String']['output'];
  type?: Maybe<DocumentType>;
  url: Scalars['String']['output'];
};

/** Type of the document */
export enum DocumentType {
  Catalogue = 'CATALOGUE',
  DeliverySchedule = 'DELIVERY_SCHEDULE',
  TermsConditions = 'TERMS_CONDITIONS',
  Various = 'VARIOUS'
}

/** Returns vat estimations based on bid amount and lot */
export type EstimatedFullPrice = {
  __typename?: 'EstimatedFullPrice';
  additionalCosts: Array<AdditionalCost>;
  additionalCostsVat?: Maybe<Money>;
  auctionCosts: Money;
  auctionCostsVat: Money;
  auctionCostsVatPercentage: Scalars['Long']['output'];
  bpm?: Maybe<Money>;
  buyerPremiumPercentage?: Maybe<Scalars['Long']['output']>;
  deposit?: Maybe<Deposit>;
  saleTerm: SaleTerm;
  subtotal: Money;
  total: Money;
  totalVat: Money;
  vat: Money;
  vatPercentage: Scalars['Long']['output'];
};

export type Filter = {
  __typename?: 'Filter';
  count: Scalars['Long']['output'];
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type FilterValues = {
  filters: Array<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['String']['input']>;
};

export type FilterValuesRequest = {
  __typename?: 'FilterValuesRequest';
  filters: Array<Scalars['String']['output']>;
  parent?: Maybe<Scalars['String']['output']>;
};

export type GroupFacetsInput = {
  biddingStatuses: Array<BiddingStatus>;
  locale: Scalars['String']['input'];
  rangeFacetInputs: Array<GroupRangeFacetInput>;
  valueFacetInputs: Array<GroupValueFacetInput>;
};

/** Group Facets result object */
export type GroupFacetsResponse = {
  __typename?: 'GroupFacetsResponse';
  appliedRangeFacets: Array<GroupRangeFacetRequest>;
  appliedValueFacets: Array<GroupValueFacetRequest>;
  rangeFacets: Array<GroupRangeFacet>;
  valueFacets: Array<GroupValueFacet>;
};

/** Location of a group */
export type GroupLocation = {
  __typename?: 'GroupLocation';
  city?: Maybe<Scalars['String']['output']>;
  countryCode: Scalars['String']['output'];
  locationId: Scalars['TbaUuid']['output'];
};

export type GroupLocationResponse = {
  __typename?: 'GroupLocationResponse';
  city?: Maybe<Scalars['String']['output']>;
  countryCode: Scalars['String']['output'];
};

/** All groups range facets for the result set. */
export type GroupRangeFacet = {
  __typename?: 'GroupRangeFacet';
  identifier: GroupRangeFacetName;
  max: Scalars['Long']['output'];
  min: Scalars['Long']['output'];
};

export type GroupRangeFacetInput = {
  identifier: GroupRangeFacetName;
  max: Scalars['Long']['input'];
  min: Scalars['Long']['input'];
};

/** Supported range facets on all groups page */
export enum GroupRangeFacetName {
  EndDates = 'endDates'
}

/** The group range facets to be applied. */
export type GroupRangeFacetRequest = {
  __typename?: 'GroupRangeFacetRequest';
  identifier: GroupRangeFacetName;
  max: Scalars['Long']['output'];
  min: Scalars['Long']['output'];
};

/** Group object */
export type GroupResponse = {
  __typename?: 'GroupResponse';
  biddingStatus: BiddingStatus;
  deliveryCountries: Array<Scalars['String']['output']>;
  endDate: Scalars['TbaDate']['output'];
  groupType: GroupType;
  id: Scalars['String']['output'];
  images: Array<Image>;
  lotCount: Scalars['Int']['output'];
  lotsClosing: Scalars['Boolean']['output'];
  maxEndDate: Scalars['TbaDate']['output'];
  name: Scalars['String']['output'];
  pickupLocations: Array<GroupLocationResponse>;
  startDate: Scalars['TbaDate']['output'];
  url3dTour?: Maybe<Scalars['String']['output']>;
  urlSlug: Scalars['String']['output'];
};

/** Type of a group (category or auction) */
export enum GroupType {
  Auction = 'AUCTION',
  Category = 'CATEGORY'
}

/** All groups value facets for the result set. */
export type GroupValueFacet = {
  __typename?: 'GroupValueFacet';
  filters: Array<Filter>;
  identifier: GroupValueFacetName;
};

export type GroupValueFacetInput = {
  filters: Array<Scalars['String']['input']>;
  identifier: GroupValueFacetName;
};

/** Supported facets on groups page */
export enum GroupValueFacetName {
  Countries = 'countries'
}

/** The group value facets to be applied. */
export type GroupValueFacetRequest = {
  __typename?: 'GroupValueFacetRequest';
  filters: Array<Scalars['String']['output']>;
  identifier: GroupValueFacetName;
};

/** Group list object */
export type GroupsResponse = {
  __typename?: 'GroupsResponse';
  hasNext: Scalars['Boolean']['output'];
  pageNumber: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  results: Array<GroupResponse>;
  totalSize: Scalars['Long']['output'];
};

/** Sorting options for groups */
export enum GroupsSortingOption {
  EndDateAsc = 'END_DATE_ASC',
  EndDateDesc = 'END_DATE_DESC',
  StartDateAsc = 'START_DATE_ASC',
  StartDateDesc = 'START_DATE_DESC'
}

export type HighlightedLotsInputV2 = {
  auctionDisplayIds: Array<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  pageNumber: Scalars['Long']['input'];
  pageSize: Scalars['Long']['input'];
};

/** Image object */
export type Image = {
  __typename?: 'Image';
  alt?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

/** Listing Lot object */
export type ListingLot = {
  __typename?: 'ListingLot';
  auctionId?: Maybe<Scalars['TbaUuid']['output']>;
  biddingStatus: BiddingStatus;
  bidsCount: Scalars['Int']['output'];
  categoryLevel3Id: Scalars['TbaUuid']['output'];
  currentBidAmount: Money;
  depositBadge: DepositBadge;
  description?: Maybe<Scalars['String']['output']>;
  displayId: Scalars['String']['output'];
  endDate: Scalars['TbaDate']['output'];
  followersCount: Scalars['Int']['output'];
  id: Scalars['TbaUuid']['output'];
  image?: Maybe<Image>;
  itemId: Scalars['TbaUuid']['output'];
  location: ListingLotLocation;
  number: Scalars['Int']['output'];
  platform: Platform;
  saleTerm: SaleTerm;
  spotlight: Scalars['Boolean']['output'];
  startDate: Scalars['TbaDate']['output'];
  title: Scalars['String']['output'];
  urlSlug: Scalars['String']['output'];
};

/** Defines the location of the viewing day or the collection day of the lot */
export type ListingLotLocation = {
  __typename?: 'ListingLotLocation';
  city?: Maybe<Scalars['String']['output']>;
  countryCode: Scalars['String']['output'];
};

/** Listing Lots list object */
export type ListingLots = {
  __typename?: 'ListingLots';
  hasNext: Scalars['Boolean']['output'];
  pageNumber: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  results: Array<ListingLot>;
  totalSize: Scalars['Long']['output'];
};

/** Localized value object */
export type LocalizedValue = {
  __typename?: 'LocalizedValue';
  locale: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type Location = {
  __typename?: 'Location';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  countryCode: Scalars['String']['output'];
  id: Scalars['TbaUuid']['output'];
  name: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
};

/** Lot object */
export type Lot = {
  __typename?: 'Lot';
  additionalCosts?: Maybe<AdditionalCosts>;
  appearance?: Maybe<Scalars['String']['output']>;
  assignedExplicitly: Scalars['Boolean']['output'];
  attributes: Array<CategoryAttribute>;
  auctionId?: Maybe<Scalars['TbaUuid']['output']>;
  auctioneerId?: Maybe<Auctioneer>;
  biddingStatus: BiddingStatus;
  bidsCount: Scalars['Int']['output'];
  buyerPremiumPercentage?: Maybe<Scalars['BigDecimal']['output']>;
  categoryInformation: LotCategoryInformation;
  companyId: Scalars['Long']['output'];
  companyType?: Maybe<BusinessType>;
  condition?: Maybe<Scalars['String']['output']>;
  currentBidAmount?: Maybe<Money>;
  customAttributes: Array<CustomAttribute>;
  depositBadge: DepositBadge;
  description: LotDescription;
  displayId: Scalars['String']['output'];
  documents: Array<Document>;
  endDate: Scalars['TbaDate']['output'];
  externalReference?: Maybe<Scalars['String']['output']>;
  followersCount: Scalars['Int']['output'];
  highestBidder?: Maybe<Scalars['TbaUuid']['output']>;
  id: Scalars['TbaUuid']['output'];
  images: Array<Image>;
  initialAmount: Money;
  insolvency: Scalars['Boolean']['output'];
  itemId: Scalars['TbaUuid']['output'];
  lcaValue?: Maybe<Scalars['BigDecimal']['output']>;
  location: Location;
  marginGood: Scalars['Boolean']['output'];
  markupPercentage: Scalars['BigDecimal']['output'];
  minimumBidAmountMet: MinimumBidAmountMet;
  nextBidStepInCents: Scalars['Long']['output'];
  nextMinimalBid: Money;
  onboarding: Scalars['Boolean']['output'];
  otherUrlSlugs: Array<LocalizedValue>;
  packaging?: Maybe<Scalars['String']['output']>;
  platform: Platform;
  quantity: Scalars['Long']['output'];
  remarks?: Maybe<Scalars['String']['output']>;
  saleTerm: SaleTerm;
  startDate: Scalars['TbaDate']['output'];
  title: Scalars['String']['output'];
  urlSlug: Scalars['String']['output'];
  vat: Scalars['BigDecimal']['output'];
  videos: Array<Video>;
  visiblePlatforms: Array<Platform>;
};


/** Lot object */
export type LotImagesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type LotAuctionFacetsInput = {
  auctionDisplayId: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  rangeFacetInputs: Array<LotRangeFacetInput>;
  requestedRangeFacetInputs: Array<LotRangeFacetName>;
  requestedValueFacetInputs: Array<LotValueFacetName>;
  valueFacetInputs: Array<LotValueFacetInput>;
  valueFilterResultSize?: InputMaybe<Scalars['Int']['input']>;
};

/** Defines the breadcrumbs for the lot-details page */
export type LotBreadCrumbs = {
  __typename?: 'LotBreadCrumbs';
  lotTitle: Scalars['String']['output'];
  slugParts: Array<SlugParts>;
};

export type LotCategoryFacetsInput = {
  categoryId: Scalars['TbaUuid']['input'];
  categoryLevel: CategoryLevel;
  locale: Scalars['String']['input'];
  nestedValueFacetInputs: Array<LotNestedValueFacetInput>;
  rangeFacetInputs: Array<LotRangeFacetInput>;
  valueFacetInputs: Array<LotValueFacetInput>;
};

export type LotCategoryFacetsInputV2 = {
  categoryId: Scalars['TbaUuid']['input'];
  categoryLevel: CategoryLevel;
  locale: Scalars['String']['input'];
  rangeFacetInputs: Array<LotRangeFacetInput>;
  requestedRangeFacetInputs: Array<LotRangeFacetName>;
  requestedValueFacetInputs: Array<LotValueFacetName>;
  valueFacetInputs: Array<LotValueFacetInput>;
  valueFilterResultSize?: InputMaybe<Scalars['Int']['input']>;
};

export type LotCategoryInformation = {
  __typename?: 'LotCategoryInformation';
  categoryLevel1: Scalars['TbaUuid']['output'];
  categoryLevel2: Scalars['TbaUuid']['output'];
  categoryLevel3: Scalars['TbaUuid']['output'];
};

/** Set of Lot data for an auction */
export type LotData = {
  __typename?: 'LotData';
  image?: Maybe<Image>;
};

/** Lot description object */
export type LotDescription = {
  __typename?: 'LotDescription';
  additionalInformation?: Maybe<Scalars['String']['output']>;
  deliveryText?: Maybe<Scalars['String']['output']>;
  deliveryUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

/** A lot details object containing one lot and its auction */
export type LotDetails = {
  __typename?: 'LotDetails';
  auction?: Maybe<Auction>;
  collectionDays?: Maybe<LotLocation>;
  estimatedFullPrice: EstimatedFullPrice;
  lot: Lot;
  viewingDays?: Maybe<LotLocation>;
};

export type LotDetailsBreadCrumbsInput = {
  locale: Scalars['String']['input'];
  lotId: Scalars['TbaUuid']['input'];
};

export type LotFacetsInput = {
  auctionDisplayId?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['TbaUuid']['input']>;
  locale: Scalars['String']['input'];
  nestedValueFacetInputs: Array<LotNestedValueFacetInput>;
  rangeFacetInputs: Array<LotRangeFacetInput>;
  valueFacetInputs: Array<LotValueFacetInput>;
};

/** Lot Facets result object */
export type LotFacetsResponse = {
  __typename?: 'LotFacetsResponse';
  appliedRangeFacets: Array<LotRangeFacetRequest>;
  appliedValueFacets: Array<LotValueFacetRequest>;
  rangeFacets: Array<LotRangeFacet>;
  valueFacets: Array<LotValueFacet>;
};

export type LotFacetsResponseV2 = {
  __typename?: 'LotFacetsResponseV2';
  appliedNestedValueFacets: Array<LotNestedValueFacetRequest>;
  appliedRangeFacets: Array<LotRangeFacetRequest>;
  appliedValueFacets: Array<LotValueFacetRequest>;
  rangeFacets: Array<LotRangeFacet>;
  valueFacets: Array<LotValueFacet>;
};

/** Defines the location of the viewing day or the collection day of the lot */
export type LotLocation = {
  __typename?: 'LotLocation';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  countryCode: Scalars['String']['output'];
  days: Array<Day>;
  name?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
};

/** Lot nested Facets result object */
export type LotNestedFacetsResponse = {
  __typename?: 'LotNestedFacetsResponse';
  valueNestedFacets: Array<LotNestedValueFacet>;
};

export type LotNestedValueFacet = {
  __typename?: 'LotNestedValueFacet';
  filters: Array<Filter>;
  identifier: LotValueNestedFacetName;
  parent: Scalars['String']['output'];
};

export type LotNestedValueFacetInput = {
  identifier: LotValueFacetName;
  values: Array<FilterValues>;
};

/** The lot value facets applied */
export type LotNestedValueFacetRequest = {
  __typename?: 'LotNestedValueFacetRequest';
  identifier: LotValueFacetName;
  values: Array<FilterValuesRequest>;
};

/** All lot range facets for the result set. */
export type LotRangeFacet = {
  __typename?: 'LotRangeFacet';
  identifier: LotRangeFacetName;
  max: Scalars['Long']['output'];
  min: Scalars['Long']['output'];
};

export type LotRangeFacetInput = {
  identifier: LotRangeFacetName;
  max: Scalars['Long']['input'];
  min: Scalars['Long']['input'];
};

/** Supported range facets on category landing page */
export enum LotRangeFacetName {
  Amounts = 'amounts',
  EndDates = 'endDates',
  YearsBuilt = 'yearsBuilt'
}

/** The lot range facets to be applied. */
export type LotRangeFacetRequest = {
  __typename?: 'LotRangeFacetRequest';
  identifier: LotRangeFacetName;
  max: Scalars['Long']['output'];
  min: Scalars['Long']['output'];
};

export type LotRequestedNestedValueFacetInput = {
  facetName: LotValueNestedFacetName;
  parent: Scalars['String']['input'];
};

/** All lot value facets for the result set. */
export type LotValueFacet = {
  __typename?: 'LotValueFacet';
  filters: Array<Filter>;
  hasNext?: Maybe<Scalars['Boolean']['output']>;
  identifier: LotValueFacetName;
};

export type LotValueFacetInput = {
  filters: Array<Scalars['String']['input']>;
  identifier: LotValueFacetName;
};

/** Supported value facets on category landing page */
export enum LotValueFacetName {
  Auctions = 'auctions',
  Brands = 'brands',
  CategoryLevel1 = 'categoryLevel1',
  CategoryLevel2 = 'categoryLevel2',
  CategoryLevel3 = 'categoryLevel3',
  Countries = 'countries',
  Status = 'status'
}

/** The lot value facets to be applied */
export type LotValueFacetRequest = {
  __typename?: 'LotValueFacetRequest';
  filters: Array<Scalars['String']['output']>;
  identifier: LotValueFacetName;
};

/** Supported nested value facets */
export enum LotValueNestedFacetName {
  CategoryLevel3 = 'categoryLevel3'
}

/** Lots list object */
export type Lots = {
  __typename?: 'Lots';
  hasNext: Scalars['Boolean']['output'];
  pageNumber: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  results: Array<Lot>;
  totalSize: Scalars['Long']['output'];
};

export type LotsByAuctionDisplayIdInput = {
  auctionDisplayId: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  pageNumber: Scalars['Long']['input'];
  pageSize: Scalars['Long']['input'];
  sortBy: LotsSortingOption;
};

export type LotsByAuctionFacet = {
  identifier: LotsByAuctionFacetName;
  values: Array<Scalars['String']['input']>;
};

/** Supported facets on auction detail page */
export enum LotsByAuctionFacetName {
  Brands = 'brands',
  CategoryLevel1 = 'categoryLevel1',
  CategoryLevel2 = 'categoryLevel2',
  CategoryLevel3 = 'categoryLevel3',
  Cities = 'cities',
  Countries = 'countries',
  Status = 'status'
}

export type LotsByAuctionValueFacetInput = {
  identifier: LotsByAuctionFacetName;
  values: Array<Scalars['String']['input']>;
};

export type LotsByCategoryIdsFacet = {
  identifier: LotsByCategoryIdsFacetName;
  values: Array<Scalars['String']['input']>;
};

/** Supported facets on category landing page */
export enum LotsByCategoryIdsFacetName {
  Auctions = 'auctions',
  Brands = 'brands',
  CategoryLevel2 = 'categoryLevel2',
  CategoryLevel3 = 'categoryLevel3',
  Cities = 'cities',
  Countries = 'countries'
}

export type LotsByCategoryIdsInputV2 = {
  categories: Array<Scalars['TbaUuid']['input']>;
  categoryLevel: CategoryLevel;
  locale: Scalars['String']['input'];
  pageNumber: Scalars['Long']['input'];
  pageSize: Scalars['Long']['input'];
  rangeFacets: Array<LotRangeFacetInput>;
  sortBy: LotsSortingOption;
  valueFacets: Array<LotsByCategoryIdsFacet>;
};

export type LotsByCompanyIdInput = {
  auctionDisplayId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['Long']['input'];
  locale: Scalars['String']['input'];
  pageNumber: Scalars['Long']['input'];
  pageSize: Scalars['Long']['input'];
  sortBy: LotsSortingOption;
};

export type LotsByIdsInput = {
  displayIds: Array<Scalars['String']['input']>;
  ids: Array<Scalars['TbaUuid']['input']>;
  locale: Scalars['String']['input'];
  sortBy: LotsSortingOption;
};

export type LotsByLocationIdInput = {
  locale: Scalars['String']['input'];
  locationId: Scalars['TbaUuid']['input'];
  pageNumber: Scalars['Long']['input'];
  pageSize: Scalars['Long']['input'];
  sortBy: LotsSortingOption;
};

/** Lot sorting order */
export enum LotsSortingOption {
  BidsCountAsc = 'BIDS_COUNT_ASC',
  BidsCountDesc = 'BIDS_COUNT_DESC',
  EndDateAsc = 'END_DATE_ASC',
  EndDateDesc = 'END_DATE_DESC',
  FollowersCountDesc = 'FOLLOWERS_COUNT_DESC',
  LotNumberAsc = 'LOT_NUMBER_ASC',
  LotNumberDesc = 'LOT_NUMBER_DESC',
  PriceAsc = 'PRICE_ASC',
  PriceDesc = 'PRICE_DESC',
  Spotlight = 'SPOTLIGHT'
}

/** Main category object */
export type MainCategory = {
  __typename?: 'MainCategory';
  id: Scalars['TbaUuid']['output'];
  name: Scalars['String']['output'];
  otherUrlSlugs: Array<LocalizedValue>;
  urlSlug: Scalars['String']['output'];
};

/** Shows if the minimum bid amount has been met */
export enum MinimumBidAmountMet {
  MinimumBidAmountMet = 'MINIMUM_BID_AMOUNT_MET',
  MinimumBidAmountNotMet = 'MINIMUM_BID_AMOUNT_NOT_MET',
  NoMinimumBidAmount = 'NO_MINIMUM_BID_AMOUNT'
}

/** Money object */
export type Money = {
  __typename?: 'Money';
  cents: Scalars['Long']['output'];
  currency: Currency;
};

/** Mutation object */
export type Mutation = {
  __typename?: 'Mutation';
  /** Save lot as favourite */
  favouriteLot: Scalars['Boolean']['output'];
  /** Attempt a bid on a lot */
  placeBid: Scalars['Boolean']['output'];
  /** Initiate platform deposit payment */
  platformDeposit: Scalars['Boolean']['output'];
  /** Request a refund for a deposit that has been paid */
  refundDeposit: Refund;
  /** Subscribe to platform deposit updates */
  subscribeDeposit: Scalars['Boolean']['output'];
  /** Subscribe to lot(s) realtime updates */
  subscribeToLots: Scalars['Boolean']['output'];
  /** Remove lot from favourites */
  unfavouriteLot: Scalars['Boolean']['output'];
  /** Unsubscribe from realtime updates for all lot(s) or a subsets of lot(s) */
  unsubscribe: Scalars['Boolean']['output'];
  /** Unsubscribe to platform deposit updates */
  unsubscribeDeposit: Scalars['Boolean']['output'];
};


/** Mutation object */
export type MutationFavouriteLotArgs = {
  id: Scalars['String']['input'];
};


/** Mutation object */
export type MutationPlaceBidArgs = {
  bidRequest: BidRequest;
};


/** Mutation object */
export type MutationPlatformDepositArgs = {
  lotId?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation object */
export type MutationRefundDepositArgs = {
  request: RefundDepositInput;
};


/** Mutation object */
export type MutationSubscribeDepositArgs = {
  connectionId: Scalars['String']['input'];
};


/** Mutation object */
export type MutationSubscribeToLotsArgs = {
  connectionId: Scalars['String']['input'];
  lotIds: Array<Scalars['TbaUuid']['input']>;
};


/** Mutation object */
export type MutationUnfavouriteLotArgs = {
  id: Scalars['String']['input'];
};


/** Mutation object */
export type MutationUnsubscribeArgs = {
  connectionId: Scalars['String']['input'];
  lotIds: Array<Scalars['TbaUuid']['input']>;
};


/** Mutation object */
export type MutationUnsubscribeDepositArgs = {
  connectionId: Scalars['String']['input'];
};

/** My Listing Lot object (my lots pages) */
export type MyListingLot = {
  __typename?: 'MyListingLot';
  auctionId?: Maybe<Scalars['TbaUuid']['output']>;
  biddingStatus: BiddingStatus;
  bidsCount: Scalars['Int']['output'];
  categoryLevel3Id: Scalars['TbaUuid']['output'];
  currentBidAmount: Money;
  deliveryCountries: Array<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayId: Scalars['String']['output'];
  endDate: Scalars['TbaDate']['output'];
  id: Scalars['TbaUuid']['output'];
  image?: Maybe<Image>;
  itemId: Scalars['TbaUuid']['output'];
  location: LotLocation;
  personalizedData: PersonalizedData;
  platform: Platform;
  saleTerm: SaleTerm;
  startDate: Scalars['TbaDate']['output'];
  title: Scalars['String']['output'];
  urlSlug: Scalars['String']['output'];
};

/** My Listing Lots list object (my lots pages) */
export type MyListingLots = {
  __typename?: 'MyListingLots';
  hasNext: Scalars['Boolean']['output'];
  pageNumber: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  results: Array<MyListingLot>;
  totalSize: Scalars['Long']['output'];
};

export type MyLotsInput = {
  locale: Scalars['String']['input'];
  pageNumber: Scalars['Long']['input'];
  pageSize: Scalars['Long']['input'];
  scope: MyLotsScope;
  sortBy: LotsSortingOption;
};

/** Filter for lots user has interacted with */
export enum MyLotsScope {
  Active = 'ACTIVE',
  All = 'ALL',
  Lost = 'LOST',
  Negotiable = 'NEGOTIABLE',
  Won = 'WON'
}

export type NestedFacetRequestInput = {
  auctionDisplayId?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['TbaUuid']['input']>;
  locale: Scalars['String']['input'];
  rangeFacetInputs: Array<LotRangeFacetInput>;
  requestedNestedValueFacetInputs: Array<LotRequestedNestedValueFacetInput>;
  valueFacetInputs: Array<LotValueFacetInput>;
};

/** Personalised deposit badge information */
export enum PersonalisedDepositBadge {
  DepositNotRequired = 'DEPOSIT_NOT_REQUIRED',
  DepositPaid = 'DEPOSIT_PAID',
  DepositRequired = 'DEPOSIT_REQUIRED',
  DepositRequirementNotReached = 'DEPOSIT_REQUIREMENT_NOT_REACHED'
}

/** Current buyerId data for a lot */
export type PersonalizedData = {
  __typename?: 'PersonalizedData';
  b2bRestricted: Scalars['Boolean']['output'];
  bidStatus: BidStatus;
  isFavourite: Scalars['Boolean']['output'];
  maxAutoBidAmount?: Maybe<Money>;
  personalisedDepositBadge: PersonalisedDepositBadge;
  personalizedLotStatus: PersonalizedLotStatus;
};

/** A lot details object containing one lot  with the buyerId data and its auction */
export type PersonalizedLotDetails = {
  __typename?: 'PersonalizedLotDetails';
  auction?: Maybe<Auction>;
  collectionDays?: Maybe<LotLocation>;
  estimatedFullPrice: EstimatedFullPrice;
  lot: Lot;
  personalizedData: PersonalizedData;
  viewingDays?: Maybe<LotLocation>;
};

/** Personalized lot data per lot id */
export type PersonalizedLotId = {
  __typename?: 'PersonalizedLotId';
  lotId: Scalars['TbaUuid']['output'];
  personalizedData: PersonalizedData;
};

/** Personalized lot status for given buyerId */
export enum PersonalizedLotStatus {
  Bid = 'BID',
  Favourite = 'FAVOURITE',
  Lost = 'LOST',
  NoRelations = 'NO_RELATIONS',
  Outbid = 'OUTBID',
  UnderAllocation = 'UNDER_ALLOCATION',
  Won = 'WON'
}

/** Platform of lots & auctions */
export enum Platform {
  Auk = 'AUK',
  Bma = 'BMA',
  Bva = 'BVA',
  Dab = 'DAB',
  Epic = 'EPIC',
  Ht = 'HT',
  KvkDk = 'KVK_DK',
  KvkFi = 'KVK_FI',
  KvkSe = 'KVK_SE',
  Ps = 'PS',
  Spx = 'SPX',
  Twk = 'TWK',
  Vavato = 'VAVATO'
}

/** Query object */
export type Query = {
  __typename?: 'Query';
  /** Return auction additional information by auction Id */
  additionalInformation: AdditionalInformationResponse;
  /**
   * Returns auctions where the bidding is open, not yet open or already closed
   * @deprecated use allAuctionsV2 instead
   */
  allAuctions: Auctions;
  /** Returns auctions where the bidding is open, not yet open or already closed */
  allAuctionsV2: Auctions;
  /**
   * Returns auctions where the bidding is open, not yet open or already closed, including a subset of lotData
   * @deprecated use allAuctionsV2 instead
   */
  allAuctionsWithLotData: AuctionsWithLotData;
  /** Returns auctions & category groups where the bidding is open, not yet open or already closed */
  allGroups: GroupsResponse;
  /** Return all lots */
  allLots: ListingLots;
  /** Return auction by id or by display id */
  auction: Auction;
  /**
   * Return Facets belonging to auctions.
   * @deprecated use auctionFacetsV2 instead
   */
  auctionFacets: AuctionFacetsResponse;
  /** Returns the previous and next lot url slugs */
  auctionNavigator: AuctionNavigation;
  /**
   * Return auction by display id together with its paged lots
   * @deprecated use auctionWithLotsV5 instead
   */
  auctionWithLots: AuctionWithLots;
  /** Return auction by display id together with its paged lots version 5 (return only limited data) */
  auctionWithLotsV5: AuctionWithListingLots;
  /** Return auctions by display ids */
  auctionsByDisplayIds: Array<Auction>;
  /**
   * Returns list with auctions that are opening soon
   * @deprecated Use auctionsWithLotDataOpeningSoonV2 instead
   */
  auctionsWithLotDataOpeningSoon: AuctionsWithLotData;
  /** Returns list with auctions that are opening soon */
  auctionsWithLotDataOpeningSoonV2: Auctions;
  /**
   * Returns list with auctions that are recently opened
   * @deprecated Use auctionsWithLotDataRecentlyOpenedV2 instead
   */
  auctionsWithLotDataRecentlyOpened: AuctionsWithLotData;
  /** Returns list with auctions that are recently opened */
  auctionsWithLotDataRecentlyOpenedV2: Auctions;
  /** Returns all level 2 categories by main category id */
  categories: Array<Category>;
  /** Returns all level 2 categories by main category id */
  categoriesV2: Array<Category>;
  /** Returns category level 2 by id */
  category: Category;
  /** Returns category level 2 by id */
  categoryV2: Category;
  /** Returns a buyers deposit status */
  depositStatus: DepositStatusResponse;
  /** Returns estimated full price of a bid, including vat */
  estimatedFullPrice: EstimatedFullPrice;
  /** Return Facets belonging to both auctions & single lots category groups. */
  groupFacets: GroupFacetsResponse;
  /** Returns a paginated list of lots that are part of the given auction display ids */
  highlightedLotsV2: ListingLots;
  /** Return Facets belonging to lots allowing category level 3 */
  lotAuctionFacets: LotFacetsResponse;
  /**
   * Returns Facets for  categoryLevel1 or categoryLevel2
   * @deprecated use lotCategoryFacetsV2 instead
   */
  lotCategoryFacets: LotFacetsResponseV2;
  /** Returns Facets for categoryLevel1 or categoryLevel2 */
  lotCategoryFacetsV2: LotFacetsResponse;
  /** Returns the lot details */
  lotDetails: LotDetails;
  /** Returns the localized bread crumbs for a lot-details page */
  lotDetailsBreadCrumbs: LotBreadCrumbs;
  /**
   * Return Facets belonging to lots.
   * @deprecated This query is deprecated as it does not support category 3 filters. Use lotAuctionFacets
   */
  lotFacets: LotFacetsResponse;
  /**
   * Return Facets belonging to lots allowing category level 3
   * @deprecated use lotAuctionFacets instead
   */
  lotFacetsV2: LotFacetsResponseV2;
  /** Returns the personalized data of lots by their ids */
  lotPersonalizedDataByIds: Array<PersonalizedLotId>;
  /**
   * Return lots by auction id or by auction display id
   * @deprecated use auctionWithLotsV5 instead
   */
  lots: Lots;
  /** Return lots belonging to the provided auction display id */
  lotsByAuctionDisplayId: ListingLots;
  /** Return lots belonging to provided main categories */
  lotsByCategoryIdsV4: ListingLots;
  /** Return lots belonging to the provided company id */
  lotsByCompanyId: ListingLots;
  /**
   * Return lots by ids or by display ids
   * @deprecated use lotsByIdsV2 instead
   */
  lotsByIds: Array<Lot>;
  /** Return lots by ids or by display ids */
  lotsByIdsV2: Array<ListingLot>;
  /** Return lots belonging to the provided location id */
  lotsByLocationId: ListingLots;
  /** Returns all main categories */
  mainCategories: Array<MainCategory>;
  /** Returns all main categories */
  mainCategoriesV2: Array<MainCategory>;
  /** Returns main category by id */
  mainCategory: MainCategory;
  /** Returns main category by id */
  mainCategoryV2: MainCategory;
  /** Returns all the lots a user has interacted with, filtered by a selected scope */
  myLotsV2: MyListingLots;
  /**
   * Returns nested facets belonging to lots
   * @deprecated This query is deprecated. Use lotAuctionFacets or lotCategoryFacetsV2
   */
  nestedLotFacets: LotNestedFacetsResponse;
  /** Returns the personalized lot details */
  personalizedLotDetails: PersonalizedLotDetails;
  /** Returns list with auction display ids for auctions that are closing first after a provided offset in hours */
  spotLightAuctionDisplayIds: AuctionDisplayIdsResponse;
  /** Returns all level 3 categories by parent category id */
  subCategories: Array<SubCategoryResponse>;
  /** Returns category level 3 by id */
  subCategory: SubCategoryResponse;
  /** Returns trending lots based on the count of followers, sorted in descending order */
  trendingLots: ListingLots;
  /** Returns the volatile and personalize data of lots by their ids */
  volatileLotDataByIds: Array<VolatileLotDataResponse>;
};


/** Query object */
export type QueryAdditionalInformationArgs = {
  request: AdditionalInformationInput;
};


/** Query object */
export type QueryAllAuctionsArgs = {
  auctionBiddingStatuses?: Array<BiddingStatus>;
  facets?: Array<AllAuctionsFacet>;
  locale: Scalars['String']['input'];
  pageNumber?: Scalars['Long']['input'];
  pageSize?: Scalars['Long']['input'];
  platform: Platform;
  sortBy?: AuctionsSortingOption;
};


/** Query object */
export type QueryAllAuctionsV2Args = {
  platform: Platform;
  request: AllAuctionsInput;
};


/** Query object */
export type QueryAllAuctionsWithLotDataArgs = {
  platform: Platform;
  request: AllAuctionsWithLotDataInput;
};


/** Query object */
export type QueryAllGroupsArgs = {
  platform: Platform;
  request: AllGroupsInput;
};


/** Query object */
export type QueryAllLotsArgs = {
  platform: Platform;
  request: SingleLotsInput;
};


/** Query object */
export type QueryAuctionArgs = {
  displayId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['TbaUuid']['input']>;
  locale: Scalars['String']['input'];
  platform: Platform;
};


/** Query object */
export type QueryAuctionFacetsArgs = {
  auctionBiddingStatuses?: Array<BiddingStatus>;
  locale: Scalars['String']['input'];
  platform: Platform;
  rangeFacetInputs?: Array<AuctionRangeFacetInput>;
  valueFacetInputs?: Array<AuctionValueFacetInput>;
};


/** Query object */
export type QueryAuctionNavigatorArgs = {
  request: AuctionNavigatorInput;
};


/** Query object */
export type QueryAuctionWithLotsArgs = {
  displayId: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  lotBiddingStatuses?: Array<BiddingStatus>;
  pageNumber?: Scalars['Long']['input'];
  pageSize?: Scalars['Long']['input'];
  platform: Platform;
  rangeFacets?: Array<LotRangeFacetInput>;
  sortBy?: LotsSortingOption;
  valueFacets?: Array<LotsByAuctionFacet>;
};


/** Query object */
export type QueryAuctionWithLotsV5Args = {
  platform: Platform;
  request: AuctionWithLotsInputV3;
};


/** Query object */
export type QueryAuctionsByDisplayIdsArgs = {
  displayIds?: Array<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  platform: Platform;
  sortBy?: AuctionsSortingOption;
};


/** Query object */
export type QueryAuctionsWithLotDataOpeningSoonArgs = {
  request: AuctionsByStateInput;
};


/** Query object */
export type QueryAuctionsWithLotDataOpeningSoonV2Args = {
  platform: Platform;
  request: AuctionsByStateInputV2;
};


/** Query object */
export type QueryAuctionsWithLotDataRecentlyOpenedArgs = {
  request: AuctionsByStateInput;
};


/** Query object */
export type QueryAuctionsWithLotDataRecentlyOpenedV2Args = {
  platform: Platform;
  request: AuctionsByStateInputV2;
};


/** Query object */
export type QueryCategoriesArgs = {
  locale: Scalars['String']['input'];
  mainCategoryId: Scalars['TbaUuid']['input'];
};


/** Query object */
export type QueryCategoriesV2Args = {
  locale: Scalars['String']['input'];
  mainCategoryId: Scalars['TbaUuid']['input'];
  platform: Platform;
};


/** Query object */
export type QueryCategoryArgs = {
  id: Scalars['TbaUuid']['input'];
  locale: Scalars['String']['input'];
};


/** Query object */
export type QueryCategoryV2Args = {
  id: Scalars['TbaUuid']['input'];
  locale: Scalars['String']['input'];
  platform: Platform;
};


/** Query object */
export type QueryDepositStatusArgs = {
  request: DepositStatusInput;
};


/** Query object */
export type QueryEstimatedFullPriceArgs = {
  bidAmount: Scalars['Long']['input'];
  currency?: Currency;
  lotId: Scalars['TbaUuid']['input'];
  platform: Platform;
};


/** Query object */
export type QueryGroupFacetsArgs = {
  platform: Platform;
  request: GroupFacetsInput;
};


/** Query object */
export type QueryHighlightedLotsV2Args = {
  platform: Platform;
  request: HighlightedLotsInputV2;
};


/** Query object */
export type QueryLotAuctionFacetsArgs = {
  platform: Platform;
  request: LotAuctionFacetsInput;
};


/** Query object */
export type QueryLotCategoryFacetsArgs = {
  platform: Platform;
  request: LotCategoryFacetsInput;
};


/** Query object */
export type QueryLotCategoryFacetsV2Args = {
  platform: Platform;
  request: LotCategoryFacetsInputV2;
};


/** Query object */
export type QueryLotDetailsArgs = {
  displayId: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  platform: Platform;
};


/** Query object */
export type QueryLotDetailsBreadCrumbsArgs = {
  platform: Platform;
  request: LotDetailsBreadCrumbsInput;
};


/** Query object */
export type QueryLotFacetsArgs = {
  auctionDisplayId?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['TbaUuid']['input']>;
  locale: Scalars['String']['input'];
  platform: Platform;
  rangeFacetInputs?: Array<LotRangeFacetInput>;
  valueFacetInputs?: Array<LotValueFacetInput>;
};


/** Query object */
export type QueryLotFacetsV2Args = {
  platform: Platform;
  request: LotFacetsInput;
};


/** Query object */
export type QueryLotPersonalizedDataByIdsArgs = {
  ids: Array<Scalars['TbaUuid']['input']>;
  platform: Platform;
};


/** Query object */
export type QueryLotsArgs = {
  auctionDisplayId?: InputMaybe<Scalars['String']['input']>;
  auctionId?: InputMaybe<Scalars['TbaUuid']['input']>;
  locale: Scalars['String']['input'];
  lotBiddingStatuses?: Array<BiddingStatus>;
  pageNumber?: Scalars['Long']['input'];
  pageSize?: Scalars['Long']['input'];
  platform: Platform;
  sortBy?: LotsSortingOption;
};


/** Query object */
export type QueryLotsByAuctionDisplayIdArgs = {
  platform: Platform;
  request: LotsByAuctionDisplayIdInput;
};


/** Query object */
export type QueryLotsByCategoryIdsV4Args = {
  platform: Platform;
  request: LotsByCategoryIdsInputV2;
};


/** Query object */
export type QueryLotsByCompanyIdArgs = {
  platform: Platform;
  request: LotsByCompanyIdInput;
};


/** Query object */
export type QueryLotsByIdsArgs = {
  displayIds?: Array<Scalars['String']['input']>;
  ids?: Array<Scalars['TbaUuid']['input']>;
  locale: Scalars['String']['input'];
  platform: Platform;
  sortBy?: LotsSortingOption;
};


/** Query object */
export type QueryLotsByIdsV2Args = {
  platform: Platform;
  request: LotsByIdsInput;
};


/** Query object */
export type QueryLotsByLocationIdArgs = {
  platform: Platform;
  request: LotsByLocationIdInput;
};


/** Query object */
export type QueryMainCategoriesArgs = {
  locale: Scalars['String']['input'];
};


/** Query object */
export type QueryMainCategoriesV2Args = {
  locale: Scalars['String']['input'];
  platform: Platform;
};


/** Query object */
export type QueryMainCategoryArgs = {
  id: Scalars['TbaUuid']['input'];
  locale: Scalars['String']['input'];
};


/** Query object */
export type QueryMainCategoryV2Args = {
  id: Scalars['TbaUuid']['input'];
  locale: Scalars['String']['input'];
  platform: Platform;
};


/** Query object */
export type QueryMyLotsV2Args = {
  platform: Platform;
  request: MyLotsInput;
};


/** Query object */
export type QueryNestedLotFacetsArgs = {
  platform: Platform;
  request: NestedFacetRequestInput;
};


/** Query object */
export type QueryPersonalizedLotDetailsArgs = {
  displayId: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  platform: Platform;
};


/** Query object */
export type QuerySpotLightAuctionDisplayIdsArgs = {
  request: SpotLightAuctionDisplayIdsInput;
};


/** Query object */
export type QuerySubCategoriesArgs = {
  locale: Scalars['String']['input'];
  parentCategoryId: Scalars['TbaUuid']['input'];
  platform: Platform;
};


/** Query object */
export type QuerySubCategoryArgs = {
  id: Scalars['TbaUuid']['input'];
  locale: Scalars['String']['input'];
  platform: Platform;
};


/** Query object */
export type QueryTrendingLotsArgs = {
  platform: Platform;
  request: TrendingLotsInput;
};


/** Query object */
export type QueryVolatileLotDataByIdsArgs = {
  platform: Platform;
  request: VolatileLotDataInput;
};

/** Response for the refund deposit request */
export type Refund = {
  __typename?: 'Refund';
  refundStatus: RefundStatus;
  rejectionReason?: Maybe<Scalars['String']['output']>;
};

export type RefundDepositInput = {
  accessType: AccessType;
  depositId: Scalars['TbaUuid']['input'];
};

/** Refund status for refund deposit request */
export enum RefundStatus {
  Denied = 'DENIED',
  Pending = 'PENDING'
}

/** Sale status of the lot */
export enum SaleTerm {
  ClosedAllocated = 'CLOSED_ALLOCATED',
  ClosedAllocationDeclined = 'CLOSED_ALLOCATION_DECLINED',
  ClosedAllocationPending = 'CLOSED_ALLOCATION_PENDING',
  ClosedReservePriceAllocated = 'CLOSED_RESERVE_PRICE_ALLOCATED',
  ClosedReservePriceAllocationDeclined = 'CLOSED_RESERVE_PRICE_ALLOCATION_DECLINED',
  ClosedReservePriceAllocationPending = 'CLOSED_RESERVE_PRICE_ALLOCATION_PENDING',
  FutureAllocationSet = 'FUTURE_ALLOCATION_SET',
  FutureReservePriceSet = 'FUTURE_RESERVE_PRICE_SET',
  GuaranteedSale = 'GUARANTEED_SALE',
  GuaranteedSaleClosed = 'GUARANTEED_SALE_CLOSED',
  OpenAllocationSet = 'OPEN_ALLOCATION_SET',
  OpenReservePriceAchieved = 'OPEN_RESERVE_PRICE_ACHIEVED',
  OpenReservePriceNotAchieved = 'OPEN_RESERVE_PRICE_NOT_ACHIEVED',
  Unsold = 'UNSOLD'
}

export type SingleLotsInput = {
  locale: Scalars['String']['input'];
  lotBiddingStatuses: Array<BiddingStatus>;
  pageNumber: Scalars['Long']['input'];
  pageSize: Scalars['Long']['input'];
  sortBy: LotsSortingOption;
};

export type SpotLightAuctionDisplayIdsInput = {
  displayIds: Array<Scalars['String']['input']>;
  offSetInHours: Scalars['Long']['input'];
  pageNumber: Scalars['Long']['input'];
  pageSize: Scalars['Long']['input'];
  platform: Platform;
};

export type SubCategoryResponse = {
  __typename?: 'SubCategoryResponse';
  id: Scalars['TbaUuid']['output'];
  name: Scalars['String']['output'];
  otherUrlSlugs: Array<LocalizedValue>;
  parentId: Scalars['TbaUuid']['output'];
  urlSlug: Scalars['String']['output'];
};

export type TrendingLotsInput = {
  locale: Scalars['String']['input'];
  pageNumber: Scalars['Long']['input'];
  pageSize: Scalars['Long']['input'];
};

/** Video object */
export type Video = {
  __typename?: 'Video';
  alt: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  thumbnail?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type VolatileLotDataInput = {
  lotIds: Array<Scalars['TbaUuid']['input']>;
};

export type VolatileLotDataResponse = {
  __typename?: 'VolatileLotDataResponse';
  b2bRestricted?: Maybe<Scalars['Boolean']['output']>;
  bidStatus?: Maybe<BidStatus>;
  biddingStatus: BiddingStatus;
  bidsCount: Scalars['Long']['output'];
  currentPriceInCents: Scalars['Long']['output'];
  endDate: Scalars['Long']['output'];
  isFavourite?: Maybe<Scalars['Boolean']['output']>;
  lotId: Scalars['TbaUuid']['output'];
  maxAutoBidAmount?: Maybe<Money>;
  personalisedDepositBadge?: Maybe<PersonalisedDepositBadge>;
  personalizedLotStatus?: Maybe<PersonalizedLotStatus>;
};

/** Object containing the information to construct the category slugs */
export type SlugParts = {
  __typename?: 'slugParts';
  displayName: Scalars['String']['output'];
  urlPart: Scalars['String']['output'];
};
